var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact13(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_562_6785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.6484 3.02734H33.7891H27.9297C22.2763 3.02734 17.5781 7.62783 17.5781 13.2812C17.5781 18.4383 21.5024 22.7184 26.4648 23.4308V27.9297C26.4648 28.5219 26.821 29.0569 27.3689 29.2829C27.9093 29.5084 28.5431 29.3875 28.9654 28.9653L33.7891 24.1417L34.3956 23.5352H39.6484C45.3019 23.5352 50 18.9347 50 13.2812C50 7.62783 45.3019 3.02734 39.6484 3.02734Z",
    fill: "#FED843"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6484 23.5352C45.3019 23.5352 50 18.9347 50 13.2812C50 7.62783 45.3019 3.02734 39.6484 3.02734H33.7891V24.1417L34.3956 23.5352H39.6484Z",
    fill: "#FABE2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3047 36.7188V42.5781C37.3047 45.127 35.2236 46.9727 32.9307 46.9727C24.4922 46.9727 16.2598 42.9834 10.1367 36.8848C4.01367 30.7861 0 22.5781 0 14.1396C0 11.7158 1.97168 9.76562 4.39453 9.76562H10.2539C10.8848 9.76562 11.4443 10.1689 11.6426 10.7666L14.5723 19.5352C14.7158 19.9648 14.6523 20.4355 14.4023 20.8115L11.918 24.5391C12.8594 26.5137 14.5254 28.6719 16.4492 30.5723C18.374 32.4717 20.5566 34.1133 22.5312 35.0547L26.2588 32.5703C26.6367 32.3213 27.1055 32.2559 27.5352 32.4004L36.3242 35.3301C36.9219 35.5283 37.3047 36.0879 37.3047 36.7188Z",
    fill: "#FF641A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.3047 36.7188V42.5781C37.3047 45.127 35.2236 46.9727 32.9307 46.9727C24.4922 46.9727 16.2598 42.9834 10.1367 36.8848L16.4492 30.5723C18.374 32.4717 20.5566 34.1133 22.5312 35.0547L26.2588 32.5703C26.6367 32.3213 27.1055 32.2559 27.5352 32.4004L36.3242 35.3301C36.9219 35.5283 37.3047 36.0879 37.3047 36.7188Z",
    fill: "#F03800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9297 14.7461C28.7387 14.7461 29.3945 14.0903 29.3945 13.2812C29.3945 12.4722 28.7387 11.8164 27.9297 11.8164C27.1207 11.8164 26.4648 12.4722 26.4648 13.2812C26.4648 14.0903 27.1207 14.7461 27.9297 14.7461Z",
    fill: "#613D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7891 14.7458C34.5981 14.7458 35.2539 14.09 35.2539 13.281C35.2539 12.472 34.5981 11.8162 33.7891 11.8162C32.9801 11.8162 32.3242 12.472 32.3242 13.281C32.3242 14.09 32.9801 14.7458 33.7891 14.7458Z",
    fill: "#613D5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2539 13.281C35.2539 12.472 34.598 11.8162 33.7891 11.8162V14.7458C34.598 14.7458 35.2539 14.09 35.2539 13.281Z",
    fill: "#4B2746"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6484 14.7458C40.4574 14.7458 41.1133 14.09 41.1133 13.281C41.1133 12.472 40.4574 11.8162 39.6484 11.8162C38.8394 11.8162 38.1836 12.472 38.1836 13.281C38.1836 14.09 38.8394 14.7458 39.6484 14.7458Z",
    fill: "#4B2746"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_562_6785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact13);
export default __webpack_public_path__ + "static/media/contact_1_3.af5924c1809eba74eb32af90d34a31e2.svg";
export { ForwardRef as ReactComponent };